<template>
  <div>
    <div >
      <button :class="{ button: filled}" type="button" @click="triggerFileInput">
        <span :class="{'button-label': filled}">{{ label }}</span>
      </button>
      <input
        type="file"
        :id="label"
        :accept="accept"
        :filled="filled"
        @change="handleFileChange"
        ref="fileInput"
        style="display: none;"
      />
    </div>
  </div>
</template>

<script>
export default {

  props: {
    modelValue: {
      type: File,
      default: () => null
    },
    label: {
      type: String,
      default: 'Choose image'
    },
    accept: {
      type: String,
      default: 'image/png'
    },
    filled:{
      type: Boolean,
      default: false
    }

  },

  emits: ['update:model-value'],

  methods: {
    handleFileChange(event) {
      this.$emit('update:model-value', event.target.files[0])
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    }
  }
}
</script>

<style lang="scss" scoped>

.button{
  position: relative;
  width: 100%;
  height: 50px;
  border-width: 0px;
  background-color: #ebeaea;
}
.button:hover {
  background-color: #c4c4c4;
  border-bottom: solid #333333 1px;
}
.button-label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 16px;
  font-size: 14px;
  color: #333333;
}
</style>